export default {
    'breakfast': 'mug-hot',
    'half board': 'utensils',
    'full board': 'utensils',
    'conference': 'user-chart',
    'bicycle': 'bicycle',
    'bicycle helmet': 'hard-hat',
    'helmet': 'hard-hat',
    'pet': 'paw',
    'dog': 'dog',
    'horse': 'horse',
    'waste water': 'water-lower',
    'electricity': 'plug',
    'bedding': 'bed-alt',
    'extra bed': 'bed-empty',
    'additional bed': 'bed-empty',
    'baby bed': 'baby',
    'child’s bed': 'baby',
    'boat': 'ship',
    'inflatable boat': 'ship',
    'towel set': 'blanket',
    'bread roll service': 'bread-loaf',
    'high chair': 'chair',
    'children’s high chair': 'chair',
    'bottle': 'glass-cheers',
    'fruit basket': 'apple-alt',
    'bouquet of flowers': 'flower-daffodil',
    'sauna': 'heat',
    'whirlpool tub': 'hot-tub',
    'whirlpool': 'hot-tub',
    'wellness': 'spa',
    'tent': 'campground',
    'motorcycle': 'motorcycle',
    'trailer': 'trailer',
    'final cleaning': 'vacuum',
    'car': 'car',
    'automobile': 'car',
    'bus': 'bus',
    'parking space': 'parking',
    'room': 'kaaba',
    'group room': 'kaaba',
    'container': 'box',
    'box': 'box',
    'barrel': 'box',
    'package': 'box',
    'pick-up service': 'shuttle-van',
    'van': 'shuttle-van',
    'shuttle': 'shuttle-van',
    'life jackets': 'swimmer',
    'swimming': 'swimmer',
    'bathing': 'swimmer',
}